import { ReactElement } from 'react';
import { Card, CardContent, Stack, Typography, Box, Divider } from '@mui/material';
import { CabSwitch } from '@CabComponents';
import { SchedulingPreferences, SchedulingPreferencesList } from '../../../store/cabinetApi/generated/scheduling';

export interface SchedulingNotificationsTabProps {
  schedulingPrefs: SchedulingPreferencesList | undefined;
  onSchedulingPrefChange: (pref: Partial<SchedulingPreferences>) => void;
}

export const SchedulingNotificationsTab = ({
  schedulingPrefs, onSchedulingPrefChange,
}: SchedulingNotificationsTabProps): ReactElement | null => {
  if (!schedulingPrefs?.user_prefs) return null;

  return (
    <Card variant="outlined" sx={{ width: '100%', padding: 1 }}>
      <CardContent>
        <Stack sx={{
          gap: 1
        }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
            <Typography>Warn me when I enable calendar holds</Typography>
            <CabSwitch
              checked={!schedulingPrefs.user_prefs.silence_executive_hold_notice}
              onChange={(e) => schedulingPrefs.user_prefs && onSchedulingPrefChange({
                id: schedulingPrefs.user_prefs.id,
                silence_executive_hold_notice: !e.target.checked,
              })}
            />
          </Box>

          <Divider />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
            <Typography>Notify me when a respondent fills out a poll</Typography>
            <CabSwitch
              checked={!schedulingPrefs.user_prefs.disable_poll_response_confirmation}
              onChange={(e) => schedulingPrefs.user_prefs && onSchedulingPrefChange({
                id: schedulingPrefs.user_prefs.id,
                disable_poll_response_confirmation: !e.target.checked,
              })}
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
